(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        if (document.querySelector(".eventlist") !== null) {
            const formElement = document.querySelector(".eventlist .event-list-filter");
            let noEventElement = document.querySelector(".eventlist .no-events");
            const resetFilterElement = document.querySelector(".eventlist .reset-all-filter");
            const loadingSpinner = document.querySelector(".eventlist .eventlist-loading");
            const filterIcon = document.querySelector(".eventlist .filter-icon");

            const topicSelectId = "event-filter-topics";
            const targetGroupSelectId = "event-filter-target-groups";
            const citySelectId = "event-filter-cities";
            const keywordsId = "event-filter-text";
            const stepSelectId = "event-filter-steps";

            const topicsInput = document.querySelector("#" + topicSelectId);
            const groupsInput = document.querySelector("#" + targetGroupSelectId);
            const citiesInput = document.querySelector("#" + citySelectId);
            const stepsInput = document.querySelector("#" + stepSelectId);

            let keywordsInput = document.getElementById(keywordsId);

            const columns = parseInt(document.querySelector(".eventlist").getAttribute("data-columns")) || 10;
            let offset = parseInt(document.querySelector(".eventlist").getAttribute("data-offset")) || 0;
            const limit = parseInt(document.querySelector(".eventlist").getAttribute("data-limit")) || 10;
            const endlessScroll =
                parseInt(document.querySelector(".eventlist").getAttribute("data-endlessscroll")) === 1;
            const showOnlyFutureEvents = document.querySelector(".eventlist").getAttribute("data-showonlyfutureevents") === "true";
            let preSelectedTopics =
                JSON.parse(document.querySelector(".eventlist").getAttribute("data-selectedtopics")) || [];
            let preSelectedTargetGroups =
                JSON.parse(document.querySelector(".eventlist").getAttribute("data-selectedtargetgroups")) || [];
            let preSelectedCities =
                JSON.parse(document.querySelector(".eventlist").getAttribute("data-selectedcities")) || [];
            let preSelectedSteps =
                JSON.parse(document.querySelector(".eventlist").getAttribute("data-selectedsteps")) || [];

            let keywords = document.querySelector(".eventlist").getAttribute("data-searchtext");
            const fromdate = document.querySelector(".eventlist").getAttribute("data-fromdate");
            const todate = document.querySelector(".eventlist").getAttribute("data-todate");

            let loading = false;

            let currentRequest = null;

            let hasMoreEvents = true;

            /**
             * Fill in the dropdowns
             */
            const params = new URLSearchParams(window.location.search);

            function getParameterValues(paramName) {
                return params.getAll(`filter[${paramName}][]`).map(decodeURIComponent);
            }

            let selectedTopics =
                getParameterValues("topic").length > 0 ? getParameterValues("topic") : preSelectedTopics;
            if (topicsInput) {
                fillDropdowns(topicsInput, selectedTopics);
            }

            let selectedTargetGroups =
                getParameterValues("targetGroup").length > 0
                    ? getParameterValues("targetGroup")
                    : preSelectedTargetGroups;
            if (groupsInput) {
                fillDropdowns(groupsInput, selectedTargetGroups);
            }

            let selectedCities = getParameterValues("city").length > 0 ? getParameterValues("city") : preSelectedCities;
            if (citiesInput) {
                fillDropdowns(citiesInput, selectedCities);
            }

            let selectedSteps =
                getParameterValues("searchSteps").length > 0 ? getParameterValues("searchSteps") : preSelectedSteps;
            if (stepsInput) {
                fillDropdowns(stepsInput, selectedSteps);
            }

            const addOrRemoveOption = (opt, array) => {
                if (opt.selected) {
                    if (!array.includes(opt.value)) array.push(opt.value);
                } else {
                    const idx = array.indexOf(opt.value);
                    if (idx > -1) array.splice(idx, 1);
                }
            };

            /**
             * Load events
             */
            const loadEvents = () => {
                if (loading) {
                    return;
                }
                loading = true;

                if (offset === 0) {
                    hasMoreEvents = true;
                }

                loadingSpinner.classList.remove("d-none");

                document.querySelector(".eventlist .eventlist-listing").classList.add("loading");

                keywords = keywordsInput ? keywordsInput.value : keywords;

                if (noEventElement !== null) {
                    noEventElement.classList.add("d-none");
                }

                selectedSteps = document.getElementById(stepSelectId)
                    ? document.getElementById(stepSelectId).value
                    : selectedSteps;

                updateBadges(stepsInput);

                if (topicsInput && topicsInput.options) {
                    Array.from(topicsInput.options).forEach((opt) => addOrRemoveOption(opt, selectedTopics));
                    updateBadges(topicsInput);
                }

                if (groupsInput && groupsInput.options) {
                    Array.from(groupsInput.options).forEach((opt) => addOrRemoveOption(opt, selectedTargetGroups));
                    updateBadges(groupsInput);
                }

                if (citiesInput && citiesInput.options) {
                    Array.from(citiesInput.options).forEach((opt) => addOrRemoveOption(opt, selectedCities));
                    updateBadges(citiesInput);
                }

                updateFilterCount();

                const url = new URL(window._AVENCY_BASE_actions.eventList, window.location.href);

                if (keywords && keywords !== "") url.searchParams.set("keywords", keywords);
                if (selectedSteps) url.searchParams.set("searchSteps", selectedSteps);
                if (selectedTopics) url.searchParams.set("topic", JSON.stringify(selectedTopics.filter((x) => !!x)));
                if (selectedTargetGroups) url.searchParams.set("targetGroup", JSON.stringify(selectedTargetGroups.filter((x) => !!x)));
                if (selectedCities) url.searchParams.set("city", JSON.stringify(selectedCities.filter((x) => !!x)));
                if (fromdate) url.searchParams.set("fromDate", fromdate);
                if (todate) url.searchParams.set("toDate", todate);

                url.searchParams.set("columns", columns);
                url.searchParams.set("offset", offset);
                url.searchParams.set("limit", limit);
                url.searchParams.set("showOnlyFutureEvents", showOnlyFutureEvents);

                currentRequest = new XMLHttpRequest();
                currentRequest.open("GET", url.toString(), true);
                currentRequest.onload = function () {
                    if (this.status >= 200 && this.status < 400 && this.response === "") {
                        hasMoreEvents = false;
                    } else if (this.status >= 200 && this.status < 400 && this.response !== "") {
                        if (endlessScroll && offset > 0) {
                            hasMoreEvents = true;
                            document.querySelector(".eventlist .eventlist-listing").innerHTML += this.response;
                        } else {
                            document.querySelector(".eventlist .eventlist-listing").innerHTML = this.response;
                        }
                        if (formElement) {
                            formElement.setAttribute("data-filtered", true);
                        }
                    } else {
                        if (!endlessScroll || offset === 0) {
                            if (noEventElement !== null) {
                                noEventElement.classList.remove("d-none");
                            }
                            document.querySelector(".eventlist .eventlist-listing").innerHTML = "";
                        }
                    }
                    document.querySelector(".eventlist .eventlist-listing").classList.remove("loading");
                    loading = false;
                    loadingSpinner.classList.add("d-none");
                };
                currentRequest.send();
            };

            // Reset all filter
            if (resetFilterElement) {
                resetFilterElement.addEventListener("click", () => {
                    window.location = window.location.href.split("?")[0];
                });
            }

            // Load events on submit
            if (formElement) {
                formElement.addEventListener("submit", (e) => {
                    e.preventDefault();
                    offset = 0;
                    if (currentRequest) {
                        currentRequest.abort();
                        currentRequest = null;
                    }
                    loading = false;
                    loadEvents();
                });
            }

            const isFilterActive = (value) => {
                if (Array.isArray(value)) {
                    const selectedValues = value.filter(
                        (item) => item != null && item !== ""
                    );
                    return selectedValues.length > 0;
                }
                return value != null && value !== "";
            };

            const updateFilterCount = () => {
                let filtersCount = 0;
                if (keywordsInput && keywordsInput.value) {
                    filtersCount++;
                }
                if (isFilterActive(selectedSteps)) {
                    filtersCount++;
                }
                if (isFilterActive(selectedTopics)) {
                    filtersCount++;
                }
                if (isFilterActive(selectedCities)) {
                    filtersCount++;
                }
                if (isFilterActive(selectedTargetGroups)) {
                    filtersCount++;
                }
                if (!filterIcon) {
                    return;
                }
                if (filtersCount === 0) {
                    filterIcon.classList.toggle("filters-set", false);
                } else {
                    filterIcon.classList.toggle("filters-set", true);
                    filterIcon.style.setProperty(
                        "--filter-count",
                        `"${filtersCount}"`
                    );
                }
            };

            // Load first batch of events
            loadEvents();

            /**
             * Check if events bottom is in viewport
             *
             * @returns {boolean}
             */
            const isInViewport = () => {
                const endlessScrollElement = document.querySelector(".eventlist .eventlist-endlessscroll");
                const bounding = endlessScrollElement.getBoundingClientRect();
                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            };

            if (endlessScroll) {
                window.addEventListener(
                    "scroll",
                    () => {
                        if (isInViewport() && !loading && hasMoreEvents) {
                            offset += limit;
                            loadEvents();
                        }
                    },
                    {passive: true}
                );
            }

            const handleInputChanges = debounce(() => {
                offset = 0;
                if (currentRequest) {
                    currentRequest.abort();
                    currentRequest = null;
                }
                loading = false;
                loadEvents();
            }, 1000);

            let dropdowns = [topicsInput, groupsInput, citiesInput, stepsInput];
            dropdowns.forEach((element) => {
                element?.addEventListener("change", handleInputChanges);
            });

            [keywordsInput].forEach((element) => {
                element?.addEventListener("input", handleInputChanges);
            });

            // Add apply-button into dropdown
            if (document.querySelector(".eventlist") !== null) {
                // Add apply-button into dropdown
                $(".dropdown-toggle").on("show.bs.dropdown", function (e) {
                    const applyButtonExists =
                        $(this).parent(".filter-dropdown.show .inner.show .apply-button-container").length > 0;
                    const applyButtonText = window._AVENCY_BASE_translations.events.applyButton;

                    if (!applyButtonExists) {
                        const applyButton =
                            '<div class="apply-button-container"><div class="apply-button d-grid gap-2"><button type="button" class="btn btn-primary">' +
                            applyButtonText +
                            "</button></div></div>";
                        $(this).parent(".filter-dropdown").find("div.inner.show").append(applyButton);
                    }
                });
            }
        }

        function fillDropdowns(dropdown, selectedValues) {
            Array.from(dropdown.children).forEach((item) => {
                if (selectedValues.includes(item.value)) {
                    item.selected = true;
                }
            });
        }

        function updateBadges(input) {
            if (!input) {
                return;
            }

            const options = Array.from(input.options);
            const selectedOptions = options.filter((opt) => opt.selected && opt.value !== "").map((opt) => opt.label);
            const activeFiltersElement = document.querySelector(".eventlist .active-filters");

            const filterGroupTemplate = document.querySelector("template#active-filters__group");
            const buttonTemplate = document.querySelector("template#active-filters__button");

            let filterGroup = document.querySelector('.active-filters__group[data-input="' + input.id + '"]');
            const filtersList = activeFiltersElement.querySelector(".active-filters__list");

            if (selectedOptions.length === 0) {
                filterGroup?.remove();
                return;
            }

            if (!filterGroup) {
                filterGroup = filterGroupTemplate.content.cloneNode(true).children[0];
                filterGroup.setAttribute("data-input", input.id);
                filterGroup.querySelector(".active-filters__label").innerText = `${input.getAttribute(
                    "title"
                )}:`;
                filtersList.appendChild(filterGroup);
            }
            const existingButtons = filterGroup.querySelectorAll("button.filter-value");
            existingButtons.forEach((button) => button.remove());

            selectedOptions.forEach((label) => {
                const button = buttonTemplate.content.cloneNode(true).children[0];
                button.querySelector(".filter-value__label").innerText = label;
                button.addEventListener("click", () => {
                    const selected = [];
                    Array.from(input.options).forEach((opt) => {
                        if (opt.label === label) {
                            opt.selected = false;
                            input.dispatchEvent(new Event('change'));
                        }
                        if (opt.selected) {
                            selected.push(opt.value)
                        }
                    });
                });
                filterGroup.appendChild(button);
            });
        }

        function debounce(callback, wait) {
            let timeoutId = null;
            return (...args) => {
                window.clearTimeout(timeoutId);
                timeoutId = window.setTimeout(() => {
                    callback(...args);
                }, wait);
            };
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
